import { useMemo, useState, useEffect } from "react";
import { asset } from "../lib/api";

// Justified photo wall: every photo keeps its own shape (no cropping); rows fill the width.
export const WeddingMosaic = ({ images = [], children, tiles = 60, overlay = 0.72 }) => {
  const [ratios, setRatios] = useState({});
  const [rowH, setRowH] = useState(190);

  useEffect(() => {
    const fit = () => setRowH(window.innerWidth < 640 ? 110 : window.innerWidth < 1024 ? 150 : 190);
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);

  const cells = useMemo(() => {
    if (!images.length) return [];
    return Array.from({ length: tiles }, (_, i) => images[i % images.length]);
  }, [images, tiles]);

  const onLoad = (src) => (e) => {
    const { naturalWidth: w, naturalHeight: h } = e.currentTarget;
    if (w && h) setRatios((r) => (r[src] ? r : { ...r, [src]: w / h }));
  };

  return (
    <div className="relative w-full h-full overflow-hidden bg-obsidian" data-testid="wedding-mosaic">
      <div className="absolute inset-0 flex flex-wrap content-start gap-1">
        {cells.map((src, i) => {
          const ar = ratios[src] || 1.5;
          const ready = !!ratios[src];
          return (
            <div key={i} data-testid="mosaic-tile" className="relative bg-white/[0.03]"
              style={{ width: `${ar * rowH}px`, flexGrow: ar }}>
              <div style={{ paddingBottom: `${100 / ar}%` }} />
              <img src={asset(src)} alt="" loading={i < 24 ? "eager" : "lazy"} onLoad={onLoad(src)}
                className={`absolute inset-0 w-full h-full transition-opacity duration-700 ${ready ? "opacity-80 hover:opacity-100" : "opacity-0"}`} />
            </div>
          );
        })}
      </div>
      <div className="absolute inset-0 pointer-events-none" style={{ background: `rgba(8,8,10,${overlay})` }} />
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(circle at 50% 45%, transparent 20%, rgba(8,8,10,0.85) 80%)" }} />
      <div className="absolute inset-x-0 bottom-0 h-1/4 pointer-events-none bg-gradient-to-t from-obsidian to-transparent" />
      <div className="absolute inset-0 flex items-center justify-center px-6">{children}</div>
    </div>
  );
};
